export default __webpack_public_path__ + "static/media/er6.6ed05791.jpg";